<div class="ui-g-12">

  <kv-search-toolbar
    [dateBoxEnabled]="true"
    [date_structure]="searchModel.date_structure"
    [card_modes]="searchModel.card_modes"
    [clusters]="searchModel.cluster_list"
    [customersBoxEnabled]="false"
    [clusterFieldEnabled]="false"
    [group_types]="searchModel.group_types"
    [groups]="searchModel.groups"
    [areas]="searchModel.areas"
    [stores]="searchModel.stores"
    [disableMutualExclusivity]="false"
    [storeSelectionMode]="'single'"
    [groupTypesFieldEnabled]="false"
    appQFilter
    (onQFilter)="searchValueTrend($event)"
  ></kv-search-toolbar>

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.indicenzaChartTitle }}</h2>
        <div class="chart-container">
          <chart [options]="incidenzaChart.options"
                 (load)="setChartInstance(incidenzaChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.scontrinoMedioChartTitle }}</h2>
        <div class="chart-container">
          <chart [options]="scontrinoMedioChart.options"
                 (load)="setChartInstance(scontrinoMedioChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/store-customers/store-customers-models/store-customers-models.component.html